/* eslint-disable */
// @ts-nocheck
import React, { useCallback, useState } from "react";
import {
  Alert,
  Modal,
  Platform,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import * as Location from "expo-location";
import { Ionicons } from "@expo/vector-icons";
// import MapView, { Marker, PROVIDER_GOOGLE } from "react-native-maps";
import { SafeAreaView } from "react-native-safe-area-context";

import ModalHeader from "@/Components/PersonalAttributes/Components/Modal/ModalHeader";

import { toReadableText } from "@/formatting/text";
import { UserCoordinate } from "@/schemas/location/cordinate";
import { UserAttributeType } from "@/schemas/profile/UserAttributeSet";

interface MapInputModalProps {
  showModal: boolean;
  closeModal: () => void;
  handleSave: (cords: UserCoordinate) => void;
  initialCords: UserCoordinate;
}

function MapInputModal({
  showModal,
  closeModal,
  handleSave,
  initialCords,
}: MapInputModalProps): React.JSX.Element {
  // const mapRef = useRef<MapView | null>(null);
  const [cords, setCords] = useState<UserCoordinate>(initialCords);
  const [searchQuery, setSearchQuery] = useState("");

  const onSave = useCallback(() => {
    handleSave(cords);
    closeModal();
  }, [cords]);

  const handleSearch = async (): Promise<void> => {
    try {
      const result = await Location.geocodeAsync(searchQuery);
      if (result.length > 0) {
        const { latitude, longitude } = result[0];
        // mapRef.current?.animateToRegion({
        //   latitude,
        //   latitudeDelta: 0.0922,
        //   longitude,
        //   longitudeDelta: 0.0421,
        // });
        setCords({ latitude, longitude });
      } else {
        Alert.alert(
          "Location Not Found",
          `We couldn't find any results for "${searchQuery}". Please try something else.`,
          [{ text: "OK" }],
        );
      }
    } catch (error) {
      Alert.alert("Something went wrong.", `Please try again later.`, [
        { text: "OK" },
      ]);
      // Todo; Capture sentry error
    }
  };

  // @ts-expect-error @ts-ignore
  const handleMapPress = async (event: {
    nativeEvent: { coordinate: UserCoordinate };
  }): Promise<void> => {
    const { latitude, longitude } = event.nativeEvent.coordinate;
    setCords({ latitude, longitude });
  };

  // @ts-expect-error @ts-ignore
  const handleMarkerDrag = (event: {
    nativeEvent: { coordinate: UserCoordinate };
  }): void => {
    setCords(event.nativeEvent.coordinate);
  };

  return (
    <Modal
      animationType="slide"
      presentationStyle="pageSheet"
      transparent={false}
      visible={showModal}
      onRequestClose={closeModal}
    >
      <SafeAreaView style={styles.modalContainer} edges={["top"]}>
        <ModalHeader
          closeModal={closeModal}
          handleSave={onSave}
          title={toReadableText(UserAttributeType.RESIDENCE)}
          saveDisabled={false}
        />
        {/* <MapView
          ref={mapRef}
          style={styles.map}
          provider={PROVIDER_GOOGLE}
          initialRegion={{
            latitude: cords.latitude,
            latitudeDelta: 0.0922,
            longitude: cords.longitude,
            longitudeDelta: 0.0421,
          }}
          onPress={handleMapPress}
        >
          <Marker coordinate={cords} draggable onDragEnd={handleMarkerDrag} />
        </MapView> */}
        <View style={styles.searchContainer}>
          <TextInput
            style={styles.searchInput}
            placeholder="Search for a location"
            value={searchQuery}
            onChangeText={setSearchQuery}
            onSubmitEditing={handleSearch}
          />
          <TouchableOpacity style={styles.searchButton} onPress={handleSearch}>
            <Ionicons name="search" size={24} color="white" />
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    backgroundColor: "#f0f0f0",
    borderRadius: 5,
    flex: 1,
    marginHorizontal: 5,
    padding: 10,
  },
  buttonContainer: {
    backgroundColor: "white",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
  },
  buttonText: {
    color: "#007AFF",
    fontWeight: "bold",
  },
  container: {
    flex: 1,
  },
  instructionContainer: {
    backgroundColor: "#f0f0f0",
    padding: 10,
  },
  instructionText: {
    color: "#333",
    textAlign: "center",
  },
  map: {
    flex: 1,
  },
  modalContainer: {
    backgroundColor: "#fff",
    flex: 1,
  },
  saveButton: {
    backgroundColor: "#007AFF",
  },
  searchButton: {
    backgroundColor: "#007AFF",
    borderRadius: 20,
    padding: 10,
  },
  searchContainer: {
    alignItems: "center",
    backgroundColor: "white",
    flexDirection: "row",
    padding: 13,
    ...Platform.select({
      android: {
        elevation: 2,
      },
      ios: {
        shadowColor: "#000",
        shadowOffset: { height: 2, width: 0 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
      },
    }),
  },
  searchInput: {
    backgroundColor: "#f0f0f0",
    borderRadius: 20,
    flex: 1,
    height: 50,
    marginRight: 10,
    paddingHorizontal: 15,
  },
});

export default MapInputModal;
